import React from 'react';
import moment from 'moment-timezone';
import constants from 'components/common/Constants/constants';
import { DeleteBulkAssignToUserCell } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/EditBulkActionRulesPage/Cells/deleteBulkAssignToUserCell';
import { RowDragHandleCell } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/EditBulkActionRulesPage/Cells/rowDragHandleCell';
import { WidgetFiltersCell } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/EditBulkActionRulesPage/Cells/widgetFiltersCell';

export const columns = [
    {
        id: 'drag-handle',
        header: '',
        cell: ({ row }) => {
            return <RowDragHandleCell rowId={row.id} />;
        },
        size: 80,
        meta: {
            isFixedSize: true,
        },
    },
    {
        id: 'ruleRank',
        header: 'Rule Rank',
        accessorKey: 'ruleRank',
        size: 140,
        meta: {
            isFixedSize: true,
        },
    },
    {
        header: 'Applied Filter',
        accessorKey: 'appliedFilter',
        cell: ({ getValue }) => {
            return <WidgetFiltersCell value={getValue()} />;
        },
        size: 450,
        meta: {
            isFixedSize: true,
        },
    },
    {
        header: 'Assignee Value',
        accessorKey: 'assigneeName',
        size: 250,
        meta: {
            isFixedSize: true,
        },
    },
    {
        header: 'Updated By',
        accessorKey: 'updatedByName',
        size: 250,
        meta: {
            isFixedSize: true,
        },
    },
    {
        header: 'Last Update',
        accessorKey: 'lastUpdate',
        accessorFn: (row) => {
            return row.lastUpdate ? moment(row.lastUpdate).format(constants.formats.date.defaultWithTime) : 'N/A';
        },
        size: 200,
        meta: {
            isFixedSize: true,
        },
    },
    {
        header: 'Last Run Affected Activities',
        accessorKey: 'lastRunActivities',
    },
    {
        id: 'delete-handle',
        header: '',
        cell: ({ row }) => {
            return <DeleteBulkAssignToUserCell row={row} />;
        },
        size: 80,
        meta: {
            isFixedSize: true,
        },
    },
];

interface ReorderRowsResponse {
    id: number;
    rank: number;
}

export const reorderRows = <T extends { id: number }>(arr: T[]): ReorderRowsResponse[] => {
    return arr.map((item, index) => {
        return { id: item.id, rank: index + 1 };
    });
};
